import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { fromEvent, Observable, Subject } from "rxjs";
import { debounceTime, takeUntil, withLatestFrom } from 'rxjs/operators';
import { LoadingSpinnerSize, LoadingSpinnerDisplayMode, LoadingSpinnerDefaultHeight, LoadingSpinnerPosition, LoadingSpinnerColorScheme } from "@shared/components/loading-spinner/loading-spinner.constants";
import { CommonModule } from "@angular/common";
import { LoadingSpinnerComponent } from "../loading-spinner/loading-spinner.component";

@Component({
  selector: "spinner-button",
  templateUrl: "./spinner-button.component.html",
  styleUrls: ["./spinner-button.component.css"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, LoadingSpinnerComponent],
})
export class SpinnerButtonComponent {
  LoadingSpinnerSize = LoadingSpinnerSize;
  LoadingSpinnerDisplayMode = LoadingSpinnerDisplayMode;
  LoadingSpinnerDefaultHeight = LoadingSpinnerDefaultHeight;
  LoadingSpinnerPosition = LoadingSpinnerPosition;
  LoadingSpinnerColorScheme = LoadingSpinnerColorScheme;

  destroy$ = new Subject();

  constructor() { }

  @ViewChild("refreshBtn", { static: true }) clickerBtn: ElementRef;

  @Input() refreshState$: Observable<boolean>;
  @Input() disabled: boolean;

  @Input() label: string;
  @Input() refreshLabel: string;

  @Output() clicked = new EventEmitter();

  ngAfterViewInit() {
    fromEvent(this.clickerBtn.nativeElement, 'click')
      .pipe(takeUntil(this.destroy$), debounceTime(300), withLatestFrom(this.refreshState$))
      .subscribe(([_, refresh]) => !refresh && this.clicked.emit());
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
